export enum DocumentType {
    Wording = 0,
    Quote = 1,
    Policy = 2,
    Certificate = 3,
    DecisionTree = 8
}